import { Button } from '@/components/ui/button';
import { BookOpen, Globe, Shield, Mic } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950">
      {/* Hero Section */}
      <div className="relative min-h-screen flex items-center justify-center overflow-hidden">

        {/* 🎬 Video Background */}
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="/Videos/landing-bg.mp4" type="video/mp4" />
        </video>

        {/* 🎥 Cinematic Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>

        {/* Content */}
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="max-w-4xl mx-auto space-y-8">

            {/* Logo/Icon */}
            <div className="flex justify-center">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 shadow-xl border border-white/20">
                <BookOpen className="w-16 h-16 text-[#D4AF37]" />
              </div>
            </div>

            {/* Title */}
            <h1
              className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-[#F8F5EE] drop-shadow-[0_4px_15px_rgba(0,0,0,0.6)]"
              style={{ fontFamily: 'Playfair Display, serif' }}
              data-testid="landing-title"
            >
              Golden Records
            </h1>

            {/* Tagline */}
            <p
              className="text-xl sm:text-2xl text-[#E2DDD5] max-w-3xl mx-auto leading-relaxed"
              data-testid="landing-tagline"
            >
              Safeguarding the World’s Literature, Voices, and Vision.
            </p>

            {/* CTA Buttons */}
            <div
              className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-8"
              data-testid="landing-cta-buttons"
            >
              <Button
                data-testid="landing-login-button"
                onClick={() => navigate('/login')}
                size="lg"
                variant="outline"
                className="border-2 border-[#D4AF37] text-[#D4AF37] bg-transparent 
                           hover:bg-[#D4AF37]/10 
                           px-10 py-6 text-lg font-semibold rounded-full 
                           shadow-lg hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] 
                           transition-all duration-300 hover:-translate-y-1"
              >
                Login
              </Button>

              <Button
                data-testid="landing-register-button"
                onClick={() => navigate('/register')}
                size="lg"
                variant="outline"
                className="border-2 border-[#D4AF37] text-[#D4AF37] bg-transparent 
                           hover:bg-[#D4AF37]/10 
                           px-10 py-6 text-lg font-semibold rounded-full 
                           shadow-lg hover:shadow-[0_0_20px_rgba(212,175,55,0.3)] 
                           transition-all duration-300 hover:-translate-y-1"
              >
                Register
              </Button>
            </div>

            {/* Feature Pills */}
            <div className="flex flex-wrap items-center justify-center gap-6 pt-12">

              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full shadow-lg border border-white/20">
                <Mic className="w-6 h-6 text-[#D4AF37]" />
                <span className="text-sm font-medium text-[#F8F5EE]">
                  Audio narration
                </span>
              </div>

              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full shadow-lg border border-white/20">
                <Globe className="w-5 h-5 text-[#D4AF37]" />
                <span className="text-sm font-medi um text-[#F8F5EE]">
                  Global Collaboration
                </span>
              </div>

              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full shadow-lg border border-white/20">
                <Shield className="w-5 h-5 text-[#D4AF37]" />
                <span className="text-sm font-medium text-[#F8F5EE]">
                  Verified & Encrypted
                </span>
              </div>

              <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full shadow-lg border border-white/20">
                <BookOpen className="w-5 h-5 text-[#D4AF37]" />
                <span className="text-sm font-medium text-[#F8F5EE]">
                  Literature Preservation
                </span>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
